const style = (theme) => {
  const output = {
    root: {
      display: 'flex',
    },
    imageWrapper: {
      position: 'relative',
      zIndex: 1,
      overflow: 'hidden',
      borderRadius: 16,
      width: '46%',
      marginRight: 80,
      '&::before': {
        content: '""',
        zIndex: 1,
        display: 'block',
        top: 0,
        left: 0,
        width: '100%',
        paddingBottom: '110%',
      },
    },
    infoWrapper: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      lineHeight: 1,
    },
    pretitle: {
      fontSize: 10,
      textTransform: 'uppercase',
    },
    title: {
      fontSize: 75,
      marginTop: 30,
      hyphens: 'auto',
    },
    text: {
      width: '66%',
      fontSize: 24,
      fontStyle: 'italic',
      marginTop: 60,
    },
    btnWrapper: {
      marginTop: 90,
      display: 'flex',
      '& > *:not(:last-child)': {
        marginRight: 15,
      },
    },
  }

  /*------------------------------
  MD
  ------------------------------*/
  output[theme.mediaInverse.md] = {
    root: {
      flexDirection: 'column',
      '& > *:not(:last-child)': {
        marginBottom: 30,
      },
    },
    imageWrapper: {
      width: '100%',
      marginRight: 0,
      '&::before': {
        paddingBottom: '56.25%',
      },
    },
    text: {
      width: '100%',
    },
    btnWrapper: {
      marginTop: 40,
    },
  }

  /*------------------------------
  SM
  ------------------------------*/
  output[theme.mediaInverse.sm] = {
    title: {
      fontSize: 45,
    },
    btnWrapper: {
      flexDirection: 'column',
      '& > *:not(:last-child)': {
        marginRight: 0,
        marginBottom: 20,
      },
    },
  }

  return output
}

export default style
